import React, { useState } from 'react';

const UnitConverter = () => {
  const [inches, setInches] = useState('0');
  const [cms, setCms] = useState('0.00');

  const handleInchesChange = (e) => {
    const value = e.target.value;
    setInches(value);

    const num = parseFloat(value) || 0;
    const converted = (num * 2.54).toFixed(2);
    setCms(converted);
  };

  const handleCmsChange = (e) => {
    const value = e.target.value;
    setCms(value);

    const num = parseFloat(value) || 0;
    const converted = (num / 2.54).toFixed(2);
    setInches(converted);
  };

  return (
    <div className="d-flex mb-16 mt-16">
      <div className='row border border-dark pt-1 pb-1 pe-4 ps-4 sm-w-100 sm-px-12' style={{width: '65%'}}>
        <label className='col col-12 body-text3 default-text'>
          Imperial to Metric Converter
        </label>
        <div className="col">
          <div className="justify-content-end align-items-center">
            <label className="form-text" htmlFor="inches-convert-input">Inches</label>
            <input
              type="number"
              className="form-control"
              id="inches-convert-input"
              value={inches}
              onChange={handleInchesChange}
            />
          </div>
        </div>

        <div className="unit-converter-equal-sign">
          <label className="form-text m-2"></label>
        </div>

        <div className="col">
          <div className="justify-content-start align-items-center">
            <label className="form-text" htmlFor="cm-convert-input">Centimetres</label>
            <input
              type="number"
              className="form-control"
              id="cm-convert-input"
              value={cms}
              onChange={handleCmsChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitConverter;